"use client"

import { useContext, useEffect, useState } from "react"
// app/components/site-header.tsx
import Image from "next/image"
import { OrganizationContext } from "@/contexts/organization"
import { useRoles } from "@/contexts/roles"
import { useTheme } from "next-themes"
import { FormattedMessage } from "react-intl"

import ActiveLink from "@/components/active-link"
import { MainNav } from "@/components/main-nav"
import OrganizationSwitcher from "@/components/organization-switcher"
import PlansDialog from "@/components/plans-dialog"
import { Search } from "@/components/search"
import { UserNav } from "@/components/user-nav"

import { Button } from "./ui/button"

export function SiteHeader() {
  const { theme } = useTheme()
  const { isAllowed } = useRoles()
  const { selectedOrganization } = useContext(OrganizationContext)
  const [isPlansDialogOpen, setIsPlansDialogOpen] = useState(false)

  useEffect(() => {
    if (
      selectedOrganization &&
      !isPlansDialogOpen &&
      (selectedOrganization.subscription_plan === null ||
        selectedOrganization.subscription_active === false)
    ) {
      setIsPlansDialogOpen(true)
    }
  }, [selectedOrganization])
  return (
    <>
      <PlansDialog
        isPlansDialogOpen={isPlansDialogOpen}
        setIsPlansDialogOpen={setIsPlansDialogOpen}
      />

      <header className="sticky top-0 z-40 w-full border-b bg-background print:hidden">
        <div className="flex h-12 items-center px-4 pt-2 mb-1 ">
          <div className="pe-2">
            <ActiveLink
              href="/workspace"
              activeClassName="text-primary-foreground"
              className=""
            >
              <svg
                width="47"
                height="47"
                viewBox="0 0 279 97"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M240.523 0L160.261 97H197.163L278.348 0H240.523Z"
                  fill="#7A86F7"
                />
                <path
                  d="M216.353 22.0771L198.086 0H160.261L197.226 45.1931L216.353 22.0771Z"
                  fill="#7A86F7"
                />
                <path
                  d="M221.556 74.9384L239.601 97H278.348L240.934 51.7845L221.556 74.9384Z"
                  fill="#7A86F7"
                />
                <path
                  d="M83.986 60.3706V82.4839H73.5807V97H47.1213V82.4839H0V60.3706L31.8106 2.03496H61.2429L29.2836 60.3706H47.1213V42.5986H73.5807V60.3706H83.986Z"
                  fill={theme === "dark" ? "#fff" : "#000"}
                />
                <path
                  d="M87.4235 97V79.3636L122.058 46.6685C127.856 41.242 132.315 36.2224 132.315 31.3385C132.315 26.5902 129.491 23.6056 123.694 23.6056C117.599 23.6056 114.031 26.4545 114.031 32.4238H87.4235C87.4235 9.4965 105.41 0 122.802 0C140.937 0 158.774 9.4965 158.774 31.2028C158.774 41.649 151.639 51.8238 142.72 60.0993L127.856 73.5301H160.261V97H87.4235Z"
                  fill={theme === "dark" ? "#fff" : "#000"}
                />
              </svg>
            </ActiveLink>
          </div>
          <div className="ml-3">
            <OrganizationSwitcher />
          </div>
          <div className="flex flex-1 items-center justify-end space-x-4">
            <nav className="flex items-center space-x-1">
              {/* <Search /> */}
              {isAllowed("OWNER", selectedOrganization?.id) &&
                selectedOrganization?.subscription_plan === "FREE" && (
                  <Button
                    size="sm"
                    className="me-3 bg-green-500 text-primary-foreground hover:bg-green-600"
                    onClick={() => setIsPlansDialogOpen(true)}
                  >
                    <FormattedMessage id="upgradePlan" />
                  </Button>
                )}
              <UserNav />
            </nav>
          </div>
        </div>
      </header>
    </>
  )
}
